<div class="modal fade" id="staticMbcExpirationBackdrop" data-bs-backdrop="static" data-bs-keyboard="false"
    tabindex="-1" aria-labelledby="staticMbcExpirationBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="dialogue-title"> {{ this.dialogService.title }} </h4>
            </div>
            <div class="modal-body">
                Poslednjeg dana u tekućem mesecu ističe rok važenja za ukupno <b>{{this.dialogService.message}} MBC</b>
                bodova.
                <pre></pre>
                Požuri i iskoristi ih pre isteka!
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn--confirm" id="btn-ok" (click)="okButtonClick()"
                    [disabled]="spinnerService.spinnerVisible">U
                    redu <app-button-spinner></app-button-spinner>
                </button>
            </div>
        </div>
    </div>
</div>